<template>
  <v-container fluid>
    <v-row justify="space-around" align="center">
      <v-col class="text-right">
      <v-btn icon @click="removeTick"><v-icon>mdi-minus</v-icon></v-btn>
      </v-col>
      <v-col class="text-center">
        <span class="title">Bonds <span class="caption text--secondary">({{ bondTrackTicks }})</span></span>
      </v-col>
      <v-col class="text-left">
      <v-btn icon @click="addTick"><v-icon>mdi-plus</v-icon></v-btn>
      </v-col>
    </v-row>
    <v-row align="center" class="my-0 py-0 text-center">
      <v-col cols="12" class="my-0 py-0">
        <svg
          v-for="box in boxes"
          :key="box"
          :width="boxHeight"
          :height="boxHeight"
          style="margin: 1px;"
        >
          <!-- outline -->
          <rect
            :height="boxHeight"
            :width="boxHeight"
            stroke-width="2"
            :stroke="strokeColor"
            fill-opacity="0"
          />
          <template v-if="box < fillingIndex">
            <!-- fully-filled -->
            <line
              x1="0"
              y1="0"
              :x2="boxHeight"
              :y2="boxHeight"
              stroke-width="1"
              :stroke="strokeColor"
            />

            <!-- top-right to bottom-left -->
            <line
              :x1="boxHeight"
              y1="0"
              x2="0"
              :y2="boxHeight"
              stroke-width="1"
              :stroke="strokeColor"
            />

            <!-- horizontal -->
            <line
              x1="0"
              :y1="halfBoxHeight"
              :x2="boxHeight"
              :y2="halfBoxHeight"
              stroke-width="1"
              :stroke="strokeColor"
            />

            <!-- vertical -->
            <line
              :x1="halfBoxHeight"
              y1="0"
              :x2="halfBoxHeight"
              :y2="boxHeight"
              stroke-width="1"
              :stroke="strokeColor"
            />
          </template>

          <template v-if="box == fillingIndex">
            <template v-if="leftoverTicks < 1"></template>

            <template v-else-if="leftoverTicks == 1">
              <!-- top-left to bottom-right -->
              <line
                x1="0"
                y1="0"
                :x2="boxHeight"
                :y2="boxHeight"
                stroke-width="1"
                :stroke="strokeColor"
              />
            </template>

            <template v-else-if="leftoverTicks == 2">
              <!-- top-left to bottom-right -->
              <line
                x1="0"
                y1="0"
                :x2="boxHeight"
                :y2="boxHeight"
                stroke-width="1"
                :stroke="strokeColor"
              />
              <!-- top-right to bottom-left -->
              <line
                :x1="boxHeight"
                y1="0"
                x2="0"
                :y2="boxHeight"
                stroke-width="1"
                :stroke="strokeColor"
              />
            </template>

            <template v-else-if="leftoverTicks == 3">
              <!-- top-left to bottom-right -->
              <line
                x1="0"
                y1="0"
                :x2="boxHeight"
                :y2="boxHeight"
                stroke-width="1"
                :stroke="strokeColor"
              />
              <!-- top-right to bottom-left -->
              <line
                :x1="boxHeight"
                y1="0"
                x2="0"
                :y2="boxHeight"
                stroke-width="1"
                :stroke="strokeColor"
              />
              <!-- horizontal -->
              <line
                x1="0"
                :y1="halfBoxHeight"
                :x2="boxHeight"
                :y2="halfBoxHeight"
                stroke-width="1"
                :stroke="strokeColor"
              />
            </template>
          </template>
        </svg>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    props: {
      onDark: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState('character', ['bondTrackTicks']),
      leftoverTicks() {
        return this.bondTrackTicks % 4;
      },
      totalProgressFilled() {
        return Math.floor(this.bondTrackTicks / 4);
      },
      fillingIndex() {
        return this.totalProgressFilled;
      },
      strokeColor() {
        if (this.onDark) {
          return 'white';
        }
        return 'black';
      },
      boxHeight() {
        return 25;
      },
      halfBoxHeight() {
        return Math.floor(this.boxHeight / 2);
      },
    },
    data() {
      return {
        boxes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      };
    },
    methods: {
      addTick() {
        this.$store.dispatch('character/addBond');
      },
      removeTick() {
        this.$store.dispatch('character/removeBond');
      },
    },
  };
</script>
